<template>
  <Dialog
    v-model:visible="visibleDialog"
    header="REGRAS DE SOLICITAÇÃO."
    :style="{ width: '700px' }"
    :modal="true"
    @hideDialog="hideDialog"
  >
    <div class="text-center">
      <i class="pi pi-exclamation-triangle" style="font-size: 6rem" />
    </div>
    <Fieldset
      v-for="rule in rules"
      :key="rule.title"
      :legend="rule.title"
      style="margin-top: 5px"
    >
      {{ rule.sub }}
    </Fieldset>
  </Dialog>
</template>

<script>
export default {
  data() {
    return {
      rules: [
        {
          title: "Regra N° 1",
          sub: "UM EVENTO NÃO PODE SER AGENDANDO NO PERÍODO CORRESPONDENTE A OUTRO EVENTO.",
        },
        {
          title: "Regra N° 2",
          sub: "UM EVENTO AGENDADO PARA O AUDITÓRIO DEVE POSSUIR NO MÍNIMO 31 E NO MÁXIMO 250 PARTICIPANTES.",
        },
        {
          title: "Regra N° 3",
          sub: "UM EVENTO AGENDADO PARA A SALA DE REUNIÕES DEVE POSSUIR NO MÍNIMO 5 E NO MÁXIMO 30 PARTICIPANTES.",
        },
        {
          title: "Regra N° 4",
          sub: "UM EVENTO SO PODERAR SER AGENDADO APOS O INTERVALO DE 30 MINUTOS DO TÉRMINO DE UM EVENTO.",
        },
        {
          title: "Regra N° 5",
          sub: "PARA EVENTOS EXTERNOS É OBRIGATÓRIO INFORMAR A LISTA DE PARTICIPANTES. FAVOR DE UTILIZA O SEGUINTE PADRÃO: NOME: JOÃO SANTOS NASCIMENTO | CPF: 000.000.000-00.",
        },
      ],
    };
  },
  computed: {
    visibleDialog: {
      get() {
        return this.$store.state.views.calendar.dialogRules;
      },
      set(value) {
        this.$store.state.views.calendar.dialogRules = value;
      },
    },
  },
};
</script>

<style></style>
